(angular => {
  "use strict";

  angular.module("App").factory("CompanyService", [
    "$q",
    "$http",
    "API",
    CompanyService
  ]);

  function CompanyService($q, $http, API) {

    const list = () => {
      return $http.get(`${API}/company`).then(result => result.data);
    };

    const listCompanyTypes = () => {
      return $http.get(`${API}/company/listCompanyTypes`).then(result => result.data);
    };

    const listSponsor = () => {
      return $http.get(`${API}/company/listSponsor`).then(result => result.data);
    };

    return {
      list,
      listCompanyTypes,
      listSponsor
    };
  }

})(angular);
